module.exports = __webpack_public_path__ + "img/sharks-3.71d30499.jpg";